import * as API from './API'

export default {

    //폰트 리스트
    async getFontList(page, size, isDisplay, fontType, searchType, searchKeyword) { 
        let parameters = {
            method: 'GET',
            path: '/p/api/font',
            params: {
                'page': page,
                'size': size,
                'isDisplay': isDisplay,
                'fontType': fontType,
                'searchType': searchType,
                'searchKeyword': searchKeyword,
                'sortType': 'sort' 
            }
        }
        const apiResponse = await API.request(parameters) 
        return apiResponse
    }

}



// WEBPACK FOOTER //
// ./src/service/fontAPI.js